/* global bocAmchart4 */

/**
 * This file is to maintain the parameters definitions.
 */
bocAmchart4.params = [];

/**
 * Chart section
 */
bocAmchart4.params.push({
    "param": "id=serial4|pie4|map4",
    "description": "Axis type should match the data type provided.",
    "default": "There's no default for this parameter, need to be provided.",
    "scope": {
        "category": ["chart"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-xAxisType=[date|number|text|time]",
    "description": "Axis type should match the data type provided. " +
        "For time series default X Axis type is date. For text category default X axis is text. " +
        "Time stamp xAxis requires 'category' dimension and keys in format of hh:mm:ss[.mmmmm] " +
        "<br><b>Examples:</b><br> " +
        "Text category chart, whether coming from time series or not, will require xAxisType parameter: " +
        "<code><br>data-xAxisType = text</code>",
    "scope": {
        "category": ["axis", "data"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-yAxisType=[number|text]",
    "description": "Axis type should match the data type provided. Default Y axis type is number. " +
        "<br><b>Examples:</b><br>" +
        "Rotated chart with text category on left vertical axis, " +
        " will require both xAxisType and yAxisType to be set: " +
        "<code><br>data-yAxisType = text<br> " +
        "data-xAxisType = number</code>",
    "default": "",
    "scope": {
        "category": ["axis", "data"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-titlestyle",
    "description": "titlestyle accepts following values to set different font sizes/styles: " +
        "big (18,12), bos(16,12), small(13,12bold), default is 14,12.",
    "scope": {
        "category": ["chart"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-charttitle",
    "description": "If data-charttitle is defined, the automatic setting of the chart titles from " +
        "group data will be skipped. These titles need to be manually defined in most cases. " +
        "No HTML is accepted in these attributes, some special features such as 2 superscript can be " +
        "done using unicode characters.",
    "scope": {
        "category": ["chart"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-subtitle",
    "description": "No HTML is accepted in these attributes, some special features such as 2 " +
        "superscript can be done using unicode characters. data-subtitle supports the substitutes " +
        "of the last date and value for the series. Use {{series0.value}} or {{series0.date}}, " +
        "replacing the 0 with series index. For now, the date will be put in the numeric form e.g. 2019-03-17",
    "scope": {
        "category": ["chart"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-matchTitlesHeightTarget = 4",
    "description": "Control the height of the titles container of the other chart from this. Number specifies the " +
        "serial number of amchart. So, to control amchart4, the parameter should be equal to 4.",
    "scope": {
        "category": ["chart"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});


bocAmchart4.params.push({
    "param": "data-height",
    "description": "Defines height of chart in pixels for screen",
    "scope": {
        "category": ["chart"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-printheight",
    "description": "Defines height of chart in pixels for print",
    "scope": {
        "category": ["chart"],
        // Maps do not have separate print
        "chart": ["serial", "pie"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-debug",
    "description": "To troubleshoot the chart, you can enable debug mode and see all the steps of the process. " +
        "This can help understand which step did not work as expected. This might be a bit code heavy " +
        "for content creators.",
    "scope": {
        "category": ["chart"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

/**
 * Data section - parameters affecting how data is loaded and processed / displayed
 */
bocAmchart4.params.push({
    "param": "data-group",
    "description": "Best way to define the data source is valet group name. Group names for SAN can be " +
        "found our from the data excel sheet normally attached to the task (groups tab) by combining the " +
        "SAN ID with group name,using underscore (e.g. SAN_DESR20180627_C3).\n" +
        " All available group names can be found from the Valet groups list " +
        "(or rather similar link - /valet/lists/groups on staging/model/local site you are working on).",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-period",
    "description": "Possible values are: [day, month, quarter, year]. Default is day, if it's not one of these, " +
        "string is passed to minPeriod (e.g. \"4MM\" will set the minimum period to 4 months, and group points " +
        "if there are multiple points in a period). If it's one of predefined values, it sets category " +
        "function too, so that cursor and category labels are properly formatted.\nColumn width is defined " +
        "relative to the min period, so if the columns are too thin, this is because they could be 1/3 of " +
        "the day on multi-year/month chart.",
    "scope": {
        "category": ["axis", "data"],
        "chart": ["serial"],
        "axis": ["date"],
        "series": ["*"]
    }
});
bocAmchart4.params.push({
    "param": "data-series{0|1|..}value",
    "description": "data-series0value = \"Series_name\" and can be used to adjust the order of series.",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}",
    "description": "If data-group is not defined, data-series0 = SERIES_ID etc. would be used to load " +
        "the data from valet by series rather than groups. If group is defined data-seires0 = \"Series_name\" " +
        "is an alias for data-series0value = \"Series_name\" and can be used to adjust the order of series.",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-calculatedSeries{0|1|..}",
    "description": "Accepts non existing series name as value. Can be used to create virtual series, " +
        "values for which are being calculated in post processing the data.",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-reservedSeries{0|1|..}",
    "description": "Reserved series would not have graphs automatically created, and rather reserved " +
        "for other usages, such as reference them for labels, or to use in calculation of some other values.",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-reserveAll=true",
    "description": "This boolean parameter reserves all series by default, except for series that " +
        "are used as arguments for other parameters. For example, if it's set to true, then all series " +
        "will automatically be reserved. If there are other arguments using a series name " +
        "(i.e. data-series0 = \"WM_SAN_DESR20180627_C3_GFI\" or data-series0openField = \"SAN_01_S01\"), " +
        "then those series will not be reserved.",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-start_date = \"2018-12-31\"",
    "description": "Start date for data request. These attributes are passed to valet to provide " +
        "the data for charts as well as are used on data export links.",
    "scope": {
        "category": ["data"],
        // It can be used to limit text date encoded as time series
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-end_date = \"2018-12-31\"",
    "description": "End date for data request. These attributes are passed to valet to provide " +
        "the data for charts as well as are used on data export links.",
    "scope": {
        "category": ["data"],
        // It can be used to limit text date encoded as time series
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-recent = 1",
    "description": "Number of recent observations to pull (can't combine any of recent params with " +
        "start end date)",
    "scope": {
        "category": ["data"],
        // It can be used to limit text date encoded as time series
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-recent{Weeks|Months|Years}",
    "description": "Date range in recent weeks, months, years can be specified with one of these " +
        "(can't combine any of the these attributes or start end date)",
    "scope": {
        "category": ["data"],
        // It can be used to limit text date encoded as time series
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-dateCrop=10Y",
    "description": "Serves 10 last years starting with January 1st.",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-datasource=\"/wp-content/uploads/2018/08/chart1data.txt\"",
    "description": "Loads data from uploads. Should not be used except in some extreme cases, " +
        "when valet data can not be used / created.",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-transpose=true",
    "description": "Switches categories and series. For category charts from date data. e.g. generating yield curves\n" +
        "Only available for data-xAxisSeries = text\n" +
        "If labels contain underscore separated category and series names, parameter will flip series and categories\n" +
        "Otherwise, dates will be used as series names and series names as categories\n" +
        "Formatting of dates will be based on data-period\n" +
        "To disable specific series' use reservedSeries.\n" +
        "If the data takes the format of many series with singular categories, you can use this parameter to swap them. " +
        "This will allow the data to be viewed as a pie chart",
    "scope": {
        "category": ["data"],
        "chart": ["serial", "pie"],
        "axis": ["text"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-categoryTerm & data-seriesTerm (DEPRECATED)",
    "description": "These two attributes were used to link the series label abbreviated notation " +
        "to more expanded text, using the terms attribute of the chart->bocSettings, but lately we " +
        "started to use the series_label to include complete labels separated by the underscore like " +
        "this: \"Baseline category_3 Month series\".\nIt's best avoid using these attributes and " +
        "eventually convert to the use of the new format for data while migrating from Amcharts3",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["text"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-addExport = false",
    "description": "Parameter to hide the export button. By default, if data comes from uploads or is encoded, exporter " +
        "will hide the data exporting options, so this parameter does not need to be used. But sometimes, it is needed " +
        "for small charts and similar cases.",
    "scope": {
        "category": ["data"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});


/**
 * Axes category
 */
bocAmchart4.params.push({
    "param": "data-{left|right|bottom|category}AxisTitle = \"Title\"",
    "description": "Defined the title to be used for specific axis.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisStackType = regular|100%",
    "description": "Defined whether the series using this axis should be stacked",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["column", "fill", "steppedFill"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisMinGridDistance = 20",
    "description": "Set minimum distance between category labels in px.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisUnit = %",
    "description": "Set string unit to add to the labels of the axis.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisUnitFirst = true",
    "description": "Place axis label unit before the value",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisReversed = true",
    "description": "Set to true to reverse an axis. Works for all value axes (right, left, bottom) " +
        "and for horizontal text axis (vertical text axis is already reversed to follow the streamline " +
        "order (so that first category appears on top)).",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value", "text"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisHideLabels = true",
    "description": "Hide axis labels.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-categoryScrollBar = true|1|2|..",
    "description": "To enable the scrollbar for bottom axis, set this to true. " +
        "To make it display the values / line etc. set it to number of the series.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["date", "text"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-skipEmptyPeriods = true",
    "description": "Skip empty data periods for date axis. Probably relevant only for columns.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["date"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisMinimum = 10",
    "description": "Set minimum of the value axis.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisMaximum = 100",
    "description": "Set maximum of the value axis.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisExtraMin = 0.1",
    "description": "Set extra space below minimum for the value axis.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisExtraMax = 0.1",
    "description": "Set extra space above maximum of the value axis.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisStrictMinMax = true",
    "description": "Force the min max parameters for the axis. when set to true, axis will scale to exact data value, " +
        "or exact maximum specified in the axis maximum / minimum, or extra maximum / minimum, rather than to the " +
        "closest full increment of the grid.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right}axisFullHeightColumns = true",
    "description": "Force the columns base (0) to be considered data for zooming purposes. When set to true, " +
        "axis will scale from 0 to max, rather than just to fit values. It should only consider columns. " +
        "Experimental, not final.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-axisSyncPrimary = left|right",
    "description": "Define which axis will sync as primary. Secondary axis will attempt to use the same grids as " +
        "primary axis. If parameter is not used while both left and right axes are in use, grids are independent and " +
        "right axis tick labels will not match the grids from the left axis, while right axis grids are always hidden.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-datezoom=10Y",
    "description": "Pre-zoom the axis to certain time in years. Will use start / end date from meta fields first, " +
        "then last date from x axis as reference and use January 1 of n years earlier as starting zoom point.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["date"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-centerDateLabels = true",
    "description": "Center date labels when possible (when they are not set for multiple periods). " +
        "This parameter is only available for DateAxis, it only expects \"true\" as a possible value. " +
        "Setting centerdatelabels to \"true\", centers the x axis labels. " +
        "The parameter is mainly meant to be used on column charts. For the amcharts that have a scrollbar, " +
        "when the range changes the labels won't always be centered. They will only be centered when " +
        "difference between 2 consecutive labels is of 1 unit (month, year or day).",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["date"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{category|left|bottom}AxisLabelMaxWidth = 200",
    "description": "Define max width of text labels. It will scale to less when available space is 1.5x " +
        "the label width or less. Preferred use is data-categoryAxisLabelMaxWidth which works for both left " +
        "and bottom text axes.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["text"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisEnableTooltips = true",
    "description": "By default, we do not display axis tooltips for axes, unless it is date axis. " +
        "To change this, this parameter can be set to false for date axis, or to true for any other axis.",
    "scope": {
        "category": ["axis", "cursor"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }


});

bocAmchart4.params.push({
    "param": "data-bottomAxisGapLimit = 120",
    "description": "By default, xAxis text labels will rotate once the gap is less than 90px. " +
        "Setting this parameter to some other number will use this instead.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["text"],
        "series": ["*"]
    }
});


bocAmchart4.params.push({
    "param": "data-multiLevel = true",
    "description": "Parse category labels and separate upper level labels to separate layer. " +
        "Uses | as a separator by default. Works with left and bottom text category.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["text"],
        "series": ["*"]
    }
});


bocAmchart4.params.push({
    "param": "data-multiLevelSeparator = '-'",
    "description": "For back compatibility, it's possible to override the separator symbol expected by data-multiLevel",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["text"],
        "series": ["*"]
    }
});


bocAmchart4.params.push({
    "param": "data-multiLevelLabelWidth = 120",
    "description": "By default, vertical left axis upper level labels for multiLevel category axis will be wrapped " +
        "after 200px, or 1/3 of the chart width. This number can be overridden with this parameter.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["text"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-{left|right|bottom}AxisMaxPrecision = 0",
    "description": "Set maximum decimals to use for the axis labels. " +
        "Might need to play with maxGridDistance for optimal results.",
    "scope": {
        "category": ["axis"],
        "chart": ["serial"],
        "axis": ["number"],
        "series": ["*"]
    }
});

/**
 * Legend category
 */
bocAmchart4.params.push({
    "param": "data-hideLegend = true",
    "description": "Hide legend.",
    "scope": {
        "category": ["legend"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-legendPeriodValueText = value.close",
    "description": "this parameter is used to define which value is to be used at the end " +
        "of the legend item when mouse is not hovered. By default there's no value. It is " +
        "used on BOS/SLOS to display values on print. It is hidden on screen by default.\n" +
        "The tags should be made out of two parts - the name of a field (value) and the value " +
        "of the period you want to be show - open / close / high / low / sum / average / count. " +
        "For example: \"value.sum\" means that sum of all data points of value field in the " +
        "selected period will be displayed.",
    "scope": {
        "category": ["legend"],
        "chart": ["serial"],
        "axis": ["date"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-showPeriodValueOnScreen = true",
    "description": "Set data-showPeriodValueOnScreen to true to show the legend period " +
        "value text on screen. Without it, the legend period value text will only show on print.",
    "scope": {
        "category": ["legend"],
        "chart": ["serial"],
        "axis": ["date"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-legendTruncateLabels = true",
    "description": "Set the legend labels to truncate to one line, instead of wrapping",
    "scope": {
        "category": ["legend"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-legendSwitchable = false",
    "description": "Set to false to disable switching the graphs by clicking on the label items.",
    "scope": {
        "category": ["legend"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-legendReverseOrder = true",
    "description": "Reverse order of items in the legend",
    "scope": {
        "category": ["legend"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});


/**
 * Notes category
 */
bocAmchart4.params.push({
    "param": "data-note = \"Source: Text\"",
    "description": "Note to appear below the chart. To get last value of the series or the last " +
        "date for the series, the following tags can be used: {{series0.value}}{{series1.date}}. " +
        "Those would work for time series and date type x axis only. \n" +
        "Shortcodes can be used, but need to use curly brackets instead of square ones: " +
        "{intlink id=1941 type=post}Internal Link{/intlink}.\n" +
        " Linebreaks can be used with \\n in the text.",
    "scope": {
        "category": ["notes"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-lastObservation = true|\"{{series0.value}}{{series1.date}}\"|Just text",
    "description": "Set to true to use default for date axis - \"Last observation: 2021Q4\" " +
        "assuming period is set to quarter. Translated for french. Or use string with possible " +
        "placeholders ({{series0.value}}{{series1.date}}) to override (only date axis).",
    "scope": {
        "category": ["notes"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-lastObservationHTML = true",
    "description": "Set to true to use html for last observation override text. " +
        "placeholders like {{series0.value}}{{series1.date}} are not supported in this case " +
        "but things like 1<sup>er</sup> are possible when manually overriding text.",
    "scope": {
        "category": ["notes"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-lastObservationOnScreen = true",
    "description": "By default the last observation note (appearing at the bottom " +
        "right of the chart) is visible only on print. Set data-lastObservationOnScreen " +
        "to true to make it appear on screen as well. This applies only to right-aligned " +
        "last observation note, not the main left aligned note, which is always visible on screen.",
    "scope": {
        "category": ["notes"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-autoHideNotes = true",
    "description": "By default, the notes are displayed below the chart, and in some cases, " +
        "they can be very large. Set data-autohidenotes to true to add a button that allows " +
        "toggling the visibility of the notes. This button will hide the notes by default on load " +
        "and show them when needed.",
    "scope": {
        "category": ["notes"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});


/**
 * Cursor / tooltips category
 */
bocAmchart4.params.push({
    "param": "data-disableCursor = true",
    "description": "Possible value: true\nCursor is enabled by default. Axis tooltips " +
        "are disabled by default. To enable tooltips for specific axis, " +
        "use data-{right|left|bottom}AxisEnableTooltips = true etc.",
    "scope": {
        "category": ["cursor"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-disableTooltips = true",
    "description": "Disables tooltips for all series. To disable specific series only, " +
        "use data-series0tooltipText = \"\" for necessary indexes.",
    "scope": {
        "category": ["cursor"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-maxTooltipDistance = true",
    "description": "Possible value: numerical, e.g. -1, 0 , 100\nLimits the radius of " +
        "activation of the tooltip around cursor (when cursor is enabled). Can be used when too many " +
        "series are active at the same time.",
    "scope": {
        "category": ["cursor"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

/**
 * Graphs / series category
 */
bocAmchart4.params.push({
    "param": "data-series{0|1|..}axis = right",
    "description": "Default is left when value axis is vertical, " +
        "and bottom when value axis is horizontal, so only right makes any difference.",
    "scope": {
        "category": ["series", "axis"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}location = 0.25",
    "description": "Position the data point within the category, " +
        "0 meaning left edge, 0.5 meaning middle etc.",
    "scope": {
        "category": ["series", "axis"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});


bocAmchart4.params.push({
    "param": "data-defaultType = column",
    "description": "Set the default type, so all the series produce this type of graphs, " +
        "unless overriden by specific parameters.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}type",
    "description": "Possible values: [line, column, scatter, bullet, fill, " +
        "marker, step, steppedFill, band, candlestick]\nDefault type depends on the chart settings, " +
        "for two automatic charts, line is default for time category, " +
        "column is default for text category.\n" +
        "candlestick, and band are the types that require data-series0openField " +
        "and data-series0closeField set to work. When thos two are set, candlestick " +
        "(floating column) is used byt default, but can be set to band to make fill " +
        "appear between two lines/ boundaries.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}openField",
    "description": "Possible values: string of the series name. " +
        "Used to create candlestick and band type graphs.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["candlestick", "band"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}closeField",
    "description": "Possible values: string of the series name. " +
        "Used to create candlestick and band type graphs.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["candlestick", "band"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}trendField",
    "description": "Possible values: string of the series name. " +
        "Create the connected line series, that syncs in legend, uses the same color etc.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet"]
    }
});


bocAmchart4.params.push({
    "param": "data-series{0|1|..}errorMinField",
    "description": "Possible values: string of the series name for the error minimum values.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "column", "line"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}errorMaxField",
    "description": "Possible values: string of the series name for the error maximum values.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "column", "line"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}errorColor",
    "description": "Color to override default color for error bar. Accepts hex code or color index. " +
        "By default, columns use black and other series use the same color as line, bullet etc.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "column", "line"]
    }
});

bocAmchart4.params.push({
    "param": "data-showColumnLabels = top|middle|true",
    "description": "Possible values: top, middle, true (same as middle). Works for columns, candlestick.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-wrapColumnLabels = true|2|3|4 etc.",
    "description": "Possible values: 2, 3, 4, etc., true (unlimited). " +
        "Wrap label to 3 (by default) for max of lines. If label does not fit, then it will be hidden.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-columnLabelText  = \"{valueY.formatNumber('#.00')}\"",
    "description": "Customize the column labels text with series, formatters etc.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}columnLabelText  = \"{valueY.formatNumber('#.00')}\"",
    "description": "Customize the specific series column labels text with series, formatters etc.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick"]
    }
});


bocAmchart4.params.push({
    "param": "data-columnLabelsFontSize  = 12",
    "description": "Set the font size for column labels.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}stacked = false",
    "description": "Prevent stacking of particular series / column. For example, " +
        "if stacked columns need to be separated into two stacks, first series in new stack need to have this " +
        "parameter to be set to false. If axis is not have stackType, then single series can be set to be stacked.",
    "scope": {
        "category": ["series", "axis"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}pattern = diagonal",
    "description": "Possible values: [diagonal, diagonal-fine, diagonal-down, checkers, stripes]. " +
        "Works for column and fill type graphs.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick", "fill"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}patternStart = 2022-01-01",
    "description": "Possible values: date or category text. Works for column and fill type graphs with date X axis. " +
        "Defines where pattern will start. Works for text category column charts as well.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["date", "text"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}patternEnd = 2022-01-01",
    "description": "Possible values: date. Works for column and fill type graphs with date X axis. " +
        "Defines where pattern will end.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["date"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}hidden = true|legend",
    "description": "Possible values: [true|legend]. " +
        "When set to true hides (disables) the graph, graying it out in the legend, " +
        "and not displaying it in the chart. When set to legend, leaves it active in graph, " +
        "but hides the corresponding item in legend.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}opacity = 0.3",
    "description": "Possible values: 0 to 1 inclusive. " +
        "Adjusts the opacity of the specific series.",
    "default": "1",
    "scope": {
        "category": ["series"],
        "chart": ["serial", "pie"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}blend = 0.3",
    "description": "Possible values: -1 to 1 inclusive. Blends of the color for specific series with background. " +
        "So, if it's 0.5 it will use 1/2 of original color and 1/2 of the white on light mode, and black on dark mode. " +
        "Accordingly -0.5 will blend to the foreground, so make the color darker on light mode and lighter on dark mode",
    "default": "1",
    "scope": {
        "category": ["series"],
        "chart": ["serial", "pie"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}legendSync = 0",
    "description": "Possible values: other series number. " +
        "Show and hide this series together with other series. " +
        "Can be used in conjunction with hiding this series in the legend.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}columnWidth = 0.5",
    "description": "Possible values: number from 0 to 1. Only used for column and candleStick graphs.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-columnWidth = 0.5",
    "description": "Possible values: number from 0 to 1. Define width for all column charts be default. " +
        "Possible values: number from 0 to 1. Only used for column and candleStick graphs. Can be override " +
        "by specific graph's parameter above.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-padding[Left|Right|Top|Bottom]",
    "description": "Padding values measured in pixels to be used for chart creation. " +
        "Defaults to 20 when the bottomAxisUnit parameter is set to ' %' on French charts. " +
        "If bottomAxisUnit is not set to ' %', the default is 15.",
    "default": "15",
    "scope": {
        "category": ["chart"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-groupSpacing = 0.5",
    "description": "Possible values: number from 0 to 1. Define spacing between groups of series. " +
        "Possible values: number from 0 to 1. Only used for column and candleStick graphs.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["column", "candlestick"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}color = 0",
    "description": "Sets the color of the line / column. Possible values: integer (to set the color from " +
        "amCharts graphs color array) or string starting with # to set HEX color code. " +
        "In a pie or donut chart, this parameter changes the color of the slices because only one series can be assigned.",
    "default": "the series number (0 for series0, 1 for series1, ..., n for seriesn)",
    "scope": {
        "category": ["series"],
        "chart": ["serial", "pie"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}lineStyle = projection",
    "description": "Sets the dash length for the line or marker type graphs. Possible values:\n" +
        "6 - dash of 6 pixel, followed by gap of 6 pixel\n" +
        "6,4,2,4 - dash of 6 pixel, followed by gap of 4 pixel, then dot, then gap of 4, then back to 6pixel dash\n" +
        "dash | projection - aliases for dash of 6 pixel, followed by gap of 6 pixel\n" +
        "dot | average | 2 - dot, followed by gap of 2 pixel, resulting in dotted line\n" +
        "data-series0dashLength is deprecated and replaced by this parameter.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["line", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}dashStart = 2022-01-01",
    "description": "Sets the start date for displaying the dashed line for the line or marker type graphs. " +
        "data-series0lineStyle should be set first to make it work. It can only be used on time series and only " +
        "for line and marker types.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["line", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}dashEnd = 2022-01-01",
    "description": "Sets the end date for displaying the dashed line for the line or marker type graphs. " +
        "data-series0lineStyle should be set first to make it work. It can only be used on time series and " +
        "only for line and marker types.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["line", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}XField",
    "description": "Possible values: string of the series name. Used for xy chart to define which series should be " +
        "used for x axis.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["value"],
        "series": ["scatter", "bullet", "line", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}tooltipText",
    "description": "Allows customization of the tooltip text; see " +
        "<a target=_blank href=\"https://www.amcharts.com/docs/v4/concepts/tooltips/\">examples from amCharts.</a> " +
        " On pie charts, data-series{0|1|..}tooltipText serves to replace the tooltips on each chart category; " +
        "this means that data-series0tooltipText replaces the tooltip for the first category. ",
    "default": "",
    "scope": {
        "category": ["series"],
        "chart": ["serial", "pie"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}bulletSize",
    "description": "Size of the bullet. Default for scatter is 7, and 14px for bullet type.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}bulletSizeField",
    "description": "Series name containing the size of the bullet. " +
        "Might need a callback to scale whatever the value provided in series to " +
        "convert to pixels for better appearance.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}shapeIndex = 0",
    "description": "Customize the bullet shape for specific series. 0 = round etc.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}labelField = SAN_PAPER_C1_S3",
    "description": "Series name containing labels for data points.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}labelText = {SAN_PAPER_C1_S3}",
    "description": "Text to appear as label. Can use {value} to display value for series.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}labelDx = 10",
    "description": "Shift labels to the right (if positive).",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}labelDy = 10",
    "description": "Shift labels to the to the bottom (if positive).",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}labelColor = \"#ffffff\"",
    "description": "Override color of the bullet label",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}labelPosition = left",
    "description": "Position for labels - default top. Can be further customized per data point by providing " +
        "'position' series inside datapoint set with op|bottom|left|right|center values.",
    "scope": {
        "category": ["series"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["scatter", "bullet", "marker"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}start",
    "description": "Main defining attribute, first guide needs to be 0 and increment by one, or remaining " +
        "attributes will be ignored. Date in format YYYY-MM-DD for date category, can be used for text " +
        "category or for values. Remember to define guide0axis to match the axis for which you define it, " +
        "unless it's bottom (default).",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}end",
    "description": "Defines end of the band guide. If absent, line guide is used. Same format as start.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}axis = left",
    "description": "Axis to use. Bottom by default (no need to set this attribute). Value axis id, " +
        "if this is value guide. Possible values: [left, right].",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}label",
    "description": "Text label to be used for the guide.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelWidth",
    "description": "Max width of the label in pixels. If label is for a band and is aligned with axis " +
        "(e.g. horizontal label for x axis band guide, the width of the band will be used as max width)",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelRotation",
    "description": "Rotate the guide label. Rotation is defined in degrees from horizontal. " +
        "To display horizontal labels on x axis, it needs to be set to 0." +
        "<br><b>Examples:</b><br>" +
        "Wrapped label positioned on the top of the x axis:" +
        "<code><br>data-guide0start = 5.13<br>" +
        "data-guide0label = \"Typical variable interest rate at the end of October 2022\"<br>" +
        "data-guide0labelMaxWidth = 150<br>" +
        "data-guide0labelRotation = 0<br>" +
        "data-guide0labelVAlign = top<br>" +
        "data-guide0labelHorizontalCenter = right" +
        "</code>",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelShiftX = 2",
    "description": "Shift label is X dimension.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelShiftY = 2",
    "description": "Shift label is Y dimension.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelAlign",
    "description": "Align the label for vertical axis guide to the right, left, or center of the chart.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelVAlign",
    "description": "Align the label for horizontal axis guide to the top, bottom, or middle of the chart.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelTextAlign",
    "description": "Change alignment of the text for wrapped labels. \"middle\" by default, " +
        "can be set to \"start\" or \"end\"",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelLocation",
    "description": "Numerical value from 0 to 1, defining the baseline for positioning the guide label. " +
        "Can be used to position label for the band. 0.5 or center of the band is default value. Can be set " +
        "to 0 to position label around lower bound, or to 1 for upper bound of the band guide.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelVerticalCenter",
    "description": "Applies to vertical axis guides. Which side of the label should touch vertical baseline " +
        "(can be adjusted with location param above for band). Setting this parameter to top would align the " +
        "top of the label with center/baseline. \"bottom\" and \"middle\" are other options. " +
        "It is set by default to \"bottom\" for vertical axis line guide, and \"middle\" for the band guide.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}labelHorizontalCenter",
    "description": "Applies to horizontal axis guides. Which side of the label should touch horizontal " +
        "baseline (can be adjusted with location param above for band). Setting this parameter to \"right\" " +
        "would align the right of the label with center/baseline. \"left\" and \"middle\" are other options. " +
        "It is set by default to \"left\" for horizontal axis line guide, and \"middle\" for the band guide.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-guide{0|1|..}showAsLine",
    "description": "Use this parameter (set to true) to make the band guideline only show boundaries line, and no fill.",
    "scope": {
        "category": ["guide"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-earlyCallback",
    "description": "Name of the function to be run early, before the chart is created. " +
        "Takes one parameter - chartSettings.",
    "scope": {
        "category": ["callbacks"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-objectCallback",
    "description": "Name of the function to be run early, after the chart is created. Takes one parameter - chart.",
    "scope": {
        "category": ["callbacks"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-dataCallback",
    "description": "Name of the function to be run right after data is downloaded. " +
        "Takes two parameters - chart, data. Data is as it appears straight from valet, as opposed to post processed " +
        "data as it appears in -callback.",
    "scope": {
        "category": ["callbacks"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-callback",
    "description": "Name of the function to be run after data was post processed and all series were defined. " +
        "Takes two parameters - chart, data.",
    "scope": {
        "category": ["callbacks"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-forcePie=true",
    "description": "Changes the appearance from donut to pie by filling in the donut hole. ",
    "default": "false",
    "scope": {
        "category": ["chart"],
        "chart": ["pie"],
        "axis": ["*"],
        "series": ["*"]
    }
});


bocAmchart4.params.push({
    "param": "data-hidePieLabels=true|768",
    "description": "Hides the labels and ticks of each category pointing to its associated slice of the pie.\n" +
        "Will hide the labels at the specified value in pixels if a numerical value is provided",
    "default": "false",
    "scope": {
        "category": ["chart"],
        "chart": ["pie"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-series{0|1|..}legendText",
    "description": "Controls the text that is displayed in the legend and its category labels. ",
    "default": "The name of the series or category",
    "scope": {
        "category": ["chart"],
        "chart": ["pie", "serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-preserveHiddenState",
    "description": "Save and re-apply the hidden state of series in chart when using interactive charts, e.g. " +
        "substituting different series data source, but keeping some series hidden",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-interactiveSeriesPrefix = MRR_TEST_",
    "description": "Define prefix so that it is not necessary to pass it in function calls.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-heatmap = true",
    "description": "This must be set to true to render a heatmap. data-defaulttype must also be set to 'column'." +
        "data-yaxistype must be set to 'text'.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-markerCount",
    "description": "Number of intervals in the legend. If data-markerCount is not defined or set to 1, it will " +
        "create a default Amcharts heat legend with gradient/default values. Otherwise, it will create a " +
        "customizable legend with either default or user-defined intervals. This parameter only works for heatmaps " +
        "and maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-minColor",
    "description": "Sets the colour for the first interval in the legend. If not defined, then it will use the " +
        "default colour. This parameter only works for heatmaps and maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-maxColor",
    "description": "Sets the colour for the last interval in the legend. If not defined, then it will use the " +
        "default colour. This parameter only works for heatmaps and maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-midColorX",
    "description": "Sets the colour for the specified X interval. The number of midColors must be equal to " +
        "markerCount-2, otherwise it will switch to default colours. This parameter only works for heatmaps and maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-minColorValue",
    "description": "Sets the starting value for the first interval in the legend. If not defined, then it will use " +
        "the default minimum value of the dataset. The number of decimal points used in this parameter also sets " +
        "the number of decimal points used for the legend. Otherwise, the legend will use number of decimal points " +
        "from the minimum value of the dataset. This parameter only works for heatmaps and maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-maxColorValue",
    "description": "Sets the end value for the last interval in the legend. If not defined, then it will use the " +
        "default maximum value of the dataset. The number of decimal points used in this parameter also sets the " +
        "number of decimal points used for the legend. If both minColorValue and maxColorValue are defined, the " +
        "number of decimal points will be set based on minColorValue. This parameter only works for heatmaps and maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-midColorValueX",
    "description": "Sets the boundary value for the specified X interval. The number of midColorValues must be equal " +
        "to markerCount-1, otherwise it will switch to default intervals. This parameter only works for heatmaps and " +
        "maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-separateOverflow",
    "description": "If this is set to true, overflow intervals will be set up in the legend. This works in " +
        "conjunction with minColorValue and maxColorValue. If it's true and minColorValue is set, then the first " +
        "interval will be '< minColorValue'. If data-separateOverflow = true and maxColorValue is set, then the last " +
        "interval will be '> maxColorValue'. If set to false, then the intervals will be split evenly. This parameter " +
        "only works for heatmaps and maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-logarithmic",
    "description": "Set to true to use logarithmic scale for spacing the legend intervals. The minimum and maximum " +
        "value of the dataset as well as user-defined minColorValue and maxColorValue cannot be 0. This parameter " +
        "only works for heatmaps and maps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "data-heatmapDisplayMidlabels",
    "description": "Set to true to display the user-defined midColorValues as labels on the heatmap legend." +
        "This parameter only works for heatmaps.",
    "scope": {
        "category": ["chart"],
        "chart": ["serial"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "bocAmchart4.customizeBullet(chart, modifiedBullets)",
    "description": "Function to modify a bullet's shape and/or color. Also updates the bullet's z-index (brings to front). modifiedBullets[] must be defined in the callback and has the following format:<br>" +
        "<pre>let modifiedBullets = [<br>" +
        "    {<br>" +
        "       x: 6.26,  // x-coordinate<br>" +
        "       y: 2.6,  // y-coordinate<br>" +
        "       color: 'red',  // hex or bocAmchart4.bocColors index also work<br>" +
        "       shape: 'circle',  // options: 'circle', 'square', 'diamond'<br>" +
        "       series: 'Pre-March 2020'  // original series of bullet<br>" +
        "    },<br>" +
        "];</pre>",
    "scope": {
        "category": ["callback"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "bocAmchart4.addLabels(chart, labels)",
    "description": "Function to add labels to a chart. labels[] must be defined in the callback and has the following format:<br>" +
        "<pre>let labels = [<br>" +
        "    {<br>" +
        "       x: 5.6,  // x-coordinate<br>" +
        "       y: 0.8,  // y-coordinate<br>" +
        "       textAlignment: 'left',<br>" +
        "       text: 'Labour market\\n returns to balance'<br>" +
        "    },<br>" +
        "];</pre>",
    "scope": {
        "category": ["callback"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});

bocAmchart4.params.push({
    "param": "bocAmchart4.addArrow(chart, startX, startY, endX, endY, lineType, lineColor, hasArrowHead)",
    "description": "Function to add arrows or straight lines(hasArrowHead = false) to a chart.<br>" +
        "<br><b>Examples:</b><br> " +
        "Draw a solid-lined blue arrow: " +
        "<code><br>bocAmchart4.addArrow(chart, 11.3, 1.9, 7.8, 4.4, 'solid', '#2984d3', true);</code>",
    "scope": {
        "category": ["callback"],
        "chart": ["*"],
        "axis": ["*"],
        "series": ["*"]
    }
});


